import React,{Component} from 'react';
import $ from 'jquery';
import Swiper from 'react-id-swiper';
import { Link } from 'react-router';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class BrandStores extends Component{
		constructor(props){
			super(props);
			this.state={
				deal_offers:[],
				is_loaded: false,
			}
			this.getStoreBrands=this.getStoreBrands.bind(this);
		}
		componentDidMount()
		{
			window.scrollTo(0, 0);							
			this.getStoreBrands()
		}
		getStoreBrands()
		{
			var data1={from:'mobile_web'};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				url:baseUrl+'brand_store',
				data:{req:data2},
				success:function(data)
				{
					this.setState({
						deal_offers:data.deal_offers,
						is_loaded:true,
					});
				}.bind(this),
				error:function(err)
				{

				}
			});
		}
	render()
	{
		const params = {
	      paginationClickable: true,
	      spaceBetween: 10,
		  slidesPerView: 'auto',
	      preloadImages: true,
	      calculateHeight:true,
	    }
		var mob_brand_blocks = this.state.deal_offers.map(function(block,index){
	    	var red_url='/';
	    	return(
	    		<Link to={block.redirect_url} className="swipe_blocks_list">
	    			{block.img ==='' ? '' : <div className="center-cropped" style={{'backgroundImage':'url("'+baseAssets+'images/'+block.img+'")','background-size':'310px 200px'}}><img className="store_brand_pic" src={baseAssets+'images/'+block.img} alt=" " /></div>}
	    		</Link>
	    	);
	    });
		return(
			<div>
			{this.state.is_loaded ? 
			<div className="brand_stores_blk">
				{mob_brand_blocks.length > 0 ? <h4 className="stores_title">BRAND STORES</h4>: ''}
				<Swiper {...params} key={mob_brand_blocks.length}>
					{mob_brand_blocks}
	            </Swiper>
			</div>
			: '' }
			</div>
		)
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Stores/BrandStores.js
 **/